import React from 'react'
import { object, string } from 'prop-types'
import MagazineLatestCTA from '@/component/Primitive/MagazineLatestCTA'

const MagazineLatestCTAWidget = ({ title, magazineIssues }) => {
  // if (!magazineIssues) return null
  const widgetProps = {
    to: '/magazine',
    title,
    magazineIssues
  }

  return <MagazineLatestCTA {...widgetProps} />
}

MagazineLatestCTAWidget.propTypes = {
  title: string.isRequired,
  magazineIssues: object.isRequired
}

export default MagazineLatestCTAWidget
